import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@mui/material';
import { BUTTON_TEXT_CANCEL } from '../../../../shared/lib/constants';
import { ConfirmationDialogProps } from '../../app/interfaceTypes';

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = BUTTON_TEXT_CANCEL,
  loading = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      PaperProps={{
        sx: { p: 1.5, borderRadius: 2 } // adds padding inside and rounded corners
      }}
    >
      <DialogTitle id="confirmation-dialog-title" sx={{ pb: 1.5 }}>
        {title}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 2 }}>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" endIcon={loading && <CircularProgress size={20} />} autoFocus disabled={loading}>
          {loading ? 'Please wait...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
